const moment = require("moment-jalaali");

export const contentTypeFilters = [
  {
    label: "فیلم",
    value: "movie",
  },
  {
    label: "انمیشن",
    value: "animation",
  },
  {
    label: "موزیک",
    value: "music",
  },
  {
    label: "سریال",
    value: "series",
  },
  {
    label: "برنامه",
    value: "program",
  },
  {
    label: "پخش زنده",
    value: "isLive",
  },
  {
    label: "آنلاین باخیش",
    value: "isTicketing",
  },
];

export const languageFilters = [
  {
    label: "انگلیسی",
    value: "english",
  },
  {
    label: "فارسی",
    value: "persian",
  },
  {
    label: "عربی",
    value: "arabic",
  },
  {
    label: "اسپانیایی",
    value: "spanish",
  },
  {
    label: "فرانسوی",
    value: "french",
  },
  {
    label: "آلمانی",
    value: "german",
  },
  {
    label: "چینی",
    value: "chinese",
  },
  {
    label: "روسی",
    value: "russian",
  },
  {
    label: "هندی",
    value: "hindi",
  },
  {
    label: "پرتغالی",
    value: "portuguese",
  },
];

export const countryFilters = [
  {
    value: "ایران",
    code: "IR",
    label: "ایران",
  },
  {
    value: "افغانستان",
    code: "AF",
    label: "افغانستان",
  },
  {
    value: "جزایر الند",
    code: "AX",
    label: "جزایر الند",
  },
  {
    value: "آلبانی",
    code: "AL",
    label: "آلبانی",
  },
  {
    value: "الجزایر",
    code: "DZ",
    label: "الجزایر",
  },
  {
    value: "ساموآی آمریکا",
    code: "AS",
    label: "ساموآی آمریکا",
  },
  {
    value: "آندورا",
    code: "AD",
    label: "آندورا",
  },
  {
    value: "آنگولا",
    code: "AO",
    label: "آنگولا",
  },
  {
    value: "آنگویلا",
    code: "AI",
    label: "آنگویلا",
  },
  {
    value: "آنتیگوآ و باربودا",
    code: "AG",
    label: "آنتیگوآ و باربودا",
  },
  {
    value: "آرژانتین",
    code: "AR",
    label: "آرژانتین",
  },
  {
    value: "ارمنستان",
    code: "AM",
    label: "ارمنستان",
  },
  {
    value: "آروبا",
    code: "AW",
    label: "آروبا",
  },
  {
    value: "استرالیا",
    code: "AU",
    label: "استرالیا",
  },
  {
    value: "اتریش",
    code: "AT",
    label: "اتریش",
  },
  {
    value: "آذربایجان",
    code: "AZ",
    label: "آذربایجان",
  },
  {
    value: "باهاما",
    code: "BS",
    label: "باهاما",
  },
  {
    value: "بحرین",
    code: "BH",
    label: "بحرین",
  },
  {
    value: "بنگلادش",
    code: "BD",
    label: "بنگلادش",
  },
  {
    value: "باربادوس",
    code: "BB",
    label: "باربادوس",
  },
  {
    value: "بلاروس",
    code: "BY",
    label: "بلاروس",
  },
  {
    value: "بلژیک",
    code: "BE",
    label: "بلژیک",
  },
  {
    value: "بلیز",
    code: "BZ",
    label: "بلیز",
  },
  {
    value: "بنین",
    code: "BJ",
    label: "بنین",
  },
  {
    value: "برمودا",
    code: "BM",
    label: "برمودا",
  },
  {
    value: "بوتان",
    code: "BT",
    label: "بوتان",
  },
  {
    value: "بولیوی",
    code: "BO",
    label: "بولیوی",
  },
  {
    value: "بوسنی و هرزگوین",
    code: "BA",
    label: "بوسنی و هرزگوین",
  },
  {
    value: "بوتسوانا",
    code: "BW",
    label: "بوتسوانا",
  },
  {
    value: "جزیره بووه",
    code: "BV",
    label: "جزیره بووه",
  },
  {
    value: "برزیل",
    code: "BR",
    label: "برزیل",
  },
  {
    value: "برونئی",
    code: "BN",
    label: "برونئی",
  },
  {
    value: "بلغارستان",
    code: "BG",
    label: "بلغارستان",
  },
  {
    value: "بورکینافاسو",
    code: "BF",
    label: "بورکینافاسو",
  },
  {
    value: "بوروندی",
    code: "BI",
    label: "بوروندی",
  },
  {
    value: "کامبوج",
    code: "KH",
    label: "کامبوج",
  },
  {
    value: "کامرون",
    code: "CM",
    label: "کامرون",
  },
  {
    value: "کانادا",
    code: "CA",
    label: "کانادا",
  },
  {
    value: "کیپ ورد",
    code: "CV",
    label: "کیپ ورد",
  },
  {
    value: "جزایر کیمن",
    code: "KY",
    label: "جزایر کیمن",
  },
  {
    value: "جمهوری آفریقای مرکزی",
    code: "CF",
    label: "جمهوری آفریقای مرکزی",
  },
  {
    value: "چاد",
    code: "TD",
    label: "چاد",
  },
  {
    value: "شیلی",
    code: "CL",
    label: "شیلی",
  },
  {
    value: "چین",
    code: "CN",
    label: "چین",
  },
  {
    value: "جزایر کریسمس",
    code: "CX",
    label: "جزایر کریسمس",
  },
  {
    value: "کلمبیا",
    code: "CO",
    label: "کلمبیا",
  },
  {
    value: "اتحاد قمر",
    code: "KM",
    label: "اتحاد قمر",
  },
  {
    value: "کنگو",
    code: "CG",
    label: "کنگو",
  },
  {
    value: "جمهوری دموکراتیک کنگو",
    code: "CD",
    label: "جمهوری دموکراتیک کنگو",
  },
  {
    value: "جزایر کوک",
    code: "CK",
    label: "جزایر کوک",
  },
  {
    value: "کاستاریکا",
    code: "CR",
    label: "کاستاریکا",
  },
  {
    value: "کرواسی",
    code: "HR",
    label: "کرواسی",
  },
  {
    value: "کوبا",
    code: "CU",
    label: "کوبا",
  },
  {
    value: "قبرس",
    code: "CY",
    label: "قبرس",
  },
  {
    value: "جمهوری چک",
    code: "CZ",
    label: "جمهوری چک",
  },
  {
    value: "دانمارک",
    code: "DK",
    label: "دانمارک",
  },
  {
    value: "جیبوتی",
    code: "DJ",
    label: "جیبوتی",
  },
  {
    value: "دومینیکا",
    code: "DM",
    label: "دومینیکا",
  },
  {
    value: "جمهوری دومینیکن",
    code: "DO",
    label: "جمهوری دومینیکن",
  },
  {
    value: "اکوادور",
    code: "EC",
    label: "اکوادور",
  },
  {
    value: "مصر",
    code: "EG",
    label: "مصر",
  },
  {
    value: "السالوادور",
    code: "SV",
    label: "السالوادور",
  },
  {
    value: "گینه استوایی",
    code: "GQ",
    label: "گینه استوایی",
  },
  {
    value: "اریتره",
    code: "ER",
    label: "اریتره",
  },
  {
    value: "استونی",
    code: "EE",
    label: "استونی",
  },
  {
    value: "اتیوپی",
    code: "ET",
    label: "اتیوپی",
  },
  {
    value: "جزایر فالکلند",
    code: "FK",
    label: "جزایر فالکلند",
  },
  {
    value: "جزایر فارو",
    code: "FO",
    label: "جزایر فارو",
  },
  {
    value: "فیجی",
    code: "FJ",
    label: "فیجی",
  },
  {
    value: "فنلاند",
    code: "FI",
    label: "فنلاند",
  },
  {
    value: "فرانسه",
    code: "FR",
    label: "فرانسه",
  },
  {
    value: "گویان فرانسه",
    code: "GF",
    label: "گویان فرانسه",
  },
  {
    value: "پولینزی فرانسوی",
    code: "PF",
    label: "پولینزی فرانسوی",
  },
  {
    value: "گابن",
    code: "GA",
    label: "گابن",
  },
  {
    value: "گامیا",
    code: "GM",
    label: "گامیا",
  },
  {
    value: "گرجستان",
    code: "GE",
    label: "گرجستان",
  },
  {
    value: "آلمان",
    code: "DE",
    label: "آلمان",
  },
  {
    value: "غنا",
    code: "GH",
    label: "غنا",
  },
  {
    value: "یونان",
    code: "GR",
    label: "یونان",
  },
  {
    value: "گرینلند",
    code: "GL",
    label: "گرینلند",
  },
  {
    value: "گرانادا",
    code: "GD",
    label: "گرانادا",
  },
  {
    value: "گوام",
    code: "GU",
    label: "گوام",
  },
  {
    value: "گواتمالا",
    code: "GT",
    label: "گواتمالا",
  },
  {
    value: "گینه",
    code: "GN",
    label: "گینه",
  },
  {
    value: "گینه بیسائو",
    code: "GW",
    label: "گینه بیسائو",
  },
  {
    value: "گویان",
    code: "GY",
    label: "گویان",
  },
  {
    value: "هاییتی",
    code: "HT",
    label: "هاییتی",
  },
  {
    value: "هندوراس",
    code: "HN",
    label: "هندوراس",
  },
  {
    value: "هنگ‌کنگ",
    code: "HK",
    label: "هنگ‌کنگ",
  },
  {
    value: "مجارستان",
    code: "HU",
    label: "مجارستان",
  },
  {
    value: "ایسلند",
    code: "IS",
    label: "ایسلند",
  },
  {
    value: "هند",
    code: "IN",
    label: "هند",
  },
  {
    value: "اندونزی",
    code: "ID",
    label: "اندونزی",
  },
  {
    value: "عراق",
    code: "IQ",
    label: "عراق",
  },
  {
    value: "ایرلند",
    code: "IE",
    label: "ایرلند",
  },
  {
    value: "اسراییل",
    code: "IL",
    label: "اسراییل",
  },
  {
    value: "ایتالیا",
    code: "IT",
    label: "ایتالیا",
  },
  {
    value: "جاماییکا",
    code: "JM",
    label: "جاماییکا",
  },
  {
    value: "ژاپن",
    code: "JP",
    label: "ژاپن",
  },
  {
    value: "اردن",
    code: "JO",
    label: "اردن",
  },
  {
    value: "قزاقستان",
    code: "KZ",
    label: "قزاقستان",
  },
  {
    value: "کنیا",
    code: "KE",
    label: "کنیا",
  },
  {
    value: "کره شمالی",
    code: "KP",
    label: "کره شمالی",
  },
  {
    value: "کره جنوبی",
    code: "KR",
    label: "کره جنوبی",
  },
  {
    value: "کویت",
    code: "KW",
    label: "کویت",
  },
  {
    value: "قرقیزستان",
    code: "KG",
    label: "قرقیزستان",
  },
  {
    value: " لائوس",
    code: "LA",
    label: " لائوس",
  },
  {
    value: "لاتویا",
    code: "LV",
    label: "لاتویا",
  },
  {
    value: "لبنان",
    code: "LB",
    label: "لبنان",
  },
  {
    value: "لسوتو",
    code: "LS",
    label: "لسوتو",
  },
  {
    value: "لیبریا",
    code: "LR",
    label: "لیبریا",
  },
  {
    value: "لیبی",
    code: "LY",
    label: "لیبی",
  },
  {
    value: "لیختنشتاین",
    code: "LI",
    label: "لیختنشتاین",
  },
  {
    value: "لیتوانی",
    code: "LT",
    label: "لیتوانی",
  },
  {
    value: "لوگزامبورگ",
    code: "LU",
    label: "لوگزامبورگ",
  },
  {
    value: "ماکائو",
    code: "MO",
    label: "ماکائو",
  },
  {
    value: "مقدونیه",
    code: "MK",
    label: "مقدونیه",
  },
  {
    value: "ماداگاسکار",
    code: "MG",
    label: "ماداگاسکار",
  },
  {
    value: "مالاوی",
    code: "MW",
    label: "مالاوی",
  },
  {
    value: "مالزی",
    code: "MY",
    label: "مالزی",
  },
  {
    value: "مالدیو",
    code: "MV",
    label: "مالدیو",
  },
  {
    value: "مالی",
    code: "ML",
    label: "مالی",
  },
  {
    value: "مالت",
    code: "MT",
    label: "مالت",
  },
  {
    value: "جزایر مارشال",
    code: "MH",
    label: "جزایر مارشال",
  },
  {
    value: "موریتانی",
    code: "MR",
    label: "موریتانی",
  },
  {
    value: "موریس",
    code: "MU",
    label: "موریس",
  },
  {
    value: "مکزیک",
    code: "MX",
    label: "مکزیک",
  },
  {
    value: "میکرونزی",
    code: "FM",
    label: "میکرونزی",
  },
  {
    value: "مولداوی",
    code: "MD",
    label: "مولداوی",
  },
  {
    value: "موناکو",
    code: "MC",
    label: "موناکو",
  },
  {
    value: "مغولستان",
    code: "MN",
    label: "مغولستان",
  },
  {
    value: "مونتنگرو",
    code: "ME",
    label: "مونتنگرو",
  },
  {
    value: "مراکش",
    code: "MA",
    label: "مراکش",
  },
  {
    value: "موزامبیک",
    code: "MZ",
    label: "موزامبیک",
  },
  {
    value: "میانمار",
    code: "MM",
    label: "میانمار",
  },
  {
    value: "نامیبیا",
    code: "NA",
    label: "نامیبیا",
  },
  {
    value: "نائورو",
    code: "NR",
    label: "نائورو",
  },
  {
    value: "نپال",
    code: "NP",
    label: "نپال",
  },
  {
    value: "هلند",
    code: "NL",
    label: "هلند",
  },
  {
    value: "آنتیل هلند",
    code: "AN",
    label: "آنتیل هلند",
  },
  {
    value: "نیوزیلند",
    code: "NZ",
    label: "نیوزیلند",
  },
  {
    value: "نیکاراگوئه",
    code: "NI",
    label: "نیکاراگوئه",
  },
  {
    value: "نیجر",
    code: "NE",
    label: "نیجر",
  },
  {
    value: "نیجریه",
    code: "NG",
    label: "نیجریه",
  },
  {
    value: "جزایر ماریان شمالی",
    code: "MP",
    label: "جزایر ماریان شمالی",
  },
  {
    value: "نروژ",
    code: "NO",
    label: "نروژ",
  },
  {
    value: "عمان",
    code: "OM",
    label: "عمان",
  },
  {
    value: "پاکستان",
    code: "PK",
    label: "پاکستان",
  },
  {
    value: "پالائو",
    code: "PW",
    label: "پالائو",
  },
  {
    value: "فلسطین",
    code: "PS",
    label: "فلسطین",
  },
  {
    value: "پاناما",
    code: "PA",
    label: "پاناما",
  },
  {
    value: "پاپوا گینه نو",
    code: "PG",
    label: "پاپوا گینه نو",
  },
  {
    value: "پاراگوئه",
    code: "PY",
    label: "پاراگوئه",
  },
  {
    value: "پرو",
    code: "PE",
    label: "پرو",
  },
  {
    value: "فیلیپین",
    code: "PH",
    label: "فیلیپین",
  },
  {
    value: "لهستان",
    code: "PL",
    label: "لهستان",
  },
  {
    value: "پرتغال",
    code: "PT",
    label: "پرتغال",
  },
  {
    value: "پورتو ریکو",
    code: "PR",
    label: "پورتو ریکو",
  },
  {
    value: "قطر",
    code: "QA",
    label: "قطر",
  },
  {
    value: "رومانی",
    code: "RO",
    label: "رومانی",
  },
  {
    value: "روسیه",
    code: "RU",
    label: "روسیه",
  },
  {
    value: "رواندا",
    code: "RW",
    label: "رواندا",
  },
  {
    value: "سنت کیتس و نویس",
    code: "KN",
    label: "سنت کیتس و نویس",
  },
  {
    value: "ساموآ",
    code: "WS",
    label: "ساموآ",
  },
  {
    value: "سن مارینو",
    code: "SM",
    label: "سن مارینو",
  },
  {
    value: "عربستان",
    code: "SA",
    label: "عربستان",
  },
  {
    value: "سنگال",
    code: "SN",
    label: "سنگال",
  },
  {
    value: "صربستان",
    code: "RS",
    label: "صربستان",
  },
  {
    value: "سیشل",
    code: "SC",
    label: "سیشل",
  },
  {
    value: "سیرالئون",
    code: "SL",
    label: "سیرالئون",
  },
  {
    value: "سنگاپور",
    code: "SG",
    label: "سنگاپور",
  },
  {
    value: "اسلوواکی",
    code: "SK",
    label: "اسلوواکی",
  },
  {
    value: "اسلوونی",
    code: "SI",
    label: "اسلوونی",
  },
  {
    value: "جزایر سلیمان",
    code: "SB",
    label: "جزایر سلیمان",
  },
  {
    value: "سومالی",
    code: "SO",
    label: "سومالی",
  },
  {
    value: "آفریقای جنوبی",
    code: "ZA",
    label: "آفریقای جنوبی",
  },
  {
    value: "اسپانیا",
    code: "ES",
    label: "اسپانیا",
  },
  {
    value: "سریلانکا",
    code: "LK",
    label: "سریلانکا",
  },
  {
    value: "سودان",
    code: "SD",
    label: "سودان",
  },
  {
    value: "سورینام",
    code: "SR",
    label: "سورینام",
  },
  {
    value: "سوازیلند",
    code: "SZ",
    label: "سوازیلند",
  },
  {
    value: "سوئد",
    code: "SE",
    label: "سوئد",
  },
  {
    value: "سوییس",
    code: "CH",
    label: "سوییس",
  },
  {
    value: "سوریه",
    code: "SY",
    label: "سوریه",
  },
  {
    value: "تایوان",
    code: "TW",
    label: "تایوان",
  },
  {
    value: "تاجیکستان",
    code: "TJ",
    label: "تاجیکستان",
  },
  {
    value: "تانزانیا",
    code: "TZ",
    label: "تانزانیا",
  },
  {
    value: "تایلند",
    code: "TH",
    label: "تایلند",
  },
  {
    value: "تیمور شرقی",
    code: "TL",
    label: "تیمور شرقی",
  },
  {
    value: "توگو",
    code: "TG",
    label: "توگو",
  },
  {
    value: "تونگا",
    code: "TO",
    label: "تونگا",
  },
  {
    value: "ترینیداد",
    code: "TT",
    label: "ترینیداد",
  },
  {
    value: "تونس",
    code: "TN",
    label: "تونس",
  },
  {
    value: "ترکیه",
    code: "TR",
    label: "ترکیه",
  },
  {
    value: "ترکمنستان",
    code: "TM",
    label: "ترکمنستان",
  },
  {
    value: "تووالو",
    code: "TV",
    label: "تووالو",
  },
  {
    value: "اوگاندا",
    code: "UG",
    label: "اوگاندا",
  },
  {
    value: "اوکراین",
    code: "UA",
    label: "اوکراین",
  },
  {
    value: "امارات متحده",
    code: "AE",
    label: "امارات متحده",
  },
  {
    value: "انگلیس",
    code: "GB",
    label: "انگلیس",
  },
  {
    value: "آمریکا",
    code: "US",
    label: "آمریکا",
  },
  {
    value: "اروگوئه",
    code: "UY",
    label: "اروگوئه",
  },
  {
    value: "ازبسکتان",
    code: "UZ",
    label: "ازبسکتان",
  },
  {
    value: "وانواتو",
    code: "VU",
    label: "وانواتو",
  },
  {
    value: "ونزوئلا",
    code: "VE",
    label: "ونزوئلا",
  },
  {
    value: "ویتنام",
    code: "VN",
    label: "ویتنام",
  },
  {
    value: "صحرای غربی",
    code: "EH",
    label: "صحرای غربی",
  },
  {
    value: "یمن",
    code: "YE",
    label: "یمن",
  },
  {
    value: "زامبیا",
    code: "ZM",
    label: "زامبیا",
  },
  {
    value: "زیمباوه",
    code: "Z",
    label: "زیمباوه",
  },
];

export const ageRangeFilters = [
  {
    label: "تا ۷ سال",
    value: 7,
  },
  {
    label: "تا ۱۳ سال",
    value: 13,
  },
  {
    label: "تا ۱۸ سال",
    value: 18,
  },
  {
    label: "بزرگسال",
    value: 120,
  },
];

export const yearFilters = Array.from(
  { length: new Date().getFullYear() - 1900 + 1 },
  (_, index) => {
    const year = 1900 + index;
    const jalaliYear = toJalali(year);
    return {
      label: `${year} (${jalaliYear})`,
      value: year.toString(),
    };
  }
);

function toJalali(year) {
  const jalaliYear = moment(year, "YYYY").format("jYYYY");

  return jalaliYear;
}

export const sortingFilters = [
  {
    label: "جدیدترین",
    value: "newest",
  },
  {
    label: "پربازدیدترین",
    value: "most-viewed",
  },
  {
    label: "پرامتیازترین",
    value: "top-rated",
  },
  {
    label: "قدیمی ترین",
    value: "oldest",
  },
];

export const anavatanCities = [
  {
    id: 0,
    name: "برگزیده",
    key: "default",
    style: "!bg-[#85000080] ml-3",
  },
  {
    id: 1,
    name: "آذربایجان شرقی",
    key: "آذربایجان-شرقی",
    bg: "/anavatan/tabriz.jpg",
  },
  {
    id: 2,
    name: "آذربایجان غربی",
    key: "آذربایجان-غربی",
    bg: "/anavatan/urmia.jpg",
  },
  {
    id: 3,
    name: "اردبیل",
    key: "اردبیل",
    bg: "/anavatan/ardabil.jpg",
  },
  {
    id: 5,
    name: "البرز",
    key: "البرز",
    bg: "/anavatan/alborz.jpg",
  },
  {
    id: 8,
    name: "تهران",
    key: "تهران",
    bg: "/anavatan/tehran.jpg",
  },
  {
    id: 14,
    name: "زنجان",
    key: "زنجان",
    bg: "/anavatan/zanjan.jpg",
  },
  {
    id: 18,
    name: "قزوین",
    key: "قزوین",
    bg: "/anavatan/qazvin.jpg",
  },
  {
    id: 19,
    name: "سایر",
    key: "سایر",
    bg: "/anavatan/default.png",
  },
];
